import * as getters from '@/store/modules/transfers/requests/internationalCorporate/getters'
import * as mutations from '@/store/modules/transfers/requests/internationalCorporate/mutations'
import * as actions from '@/store/modules/transfers/requests/internationalCorporate/actions'

const state = {
	processesList: [],
	processesListHasMore: false,
	tmxCurrencyList: [],
	tmxEstimatedAmount: {}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
